import React from 'react';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import Dialog from '../network_support_question_create';
import { useQueryClient } from '@tanstack/react-query';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';

export default function Launcher(props) {
  const config = useDialogConfig();
  const queryClient = useQueryClient();

  const supportQuestion = useConnect('supportQuestion.byId', {
    id: config.params.supportQuestionId
  });

  if (supportQuestion.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <Dialog
      supportQuestion={supportQuestion}
      onClose={props.onClose}
      onSubmit={function(request) {
        queryClient.invalidateQueries({ queryKey: ['networkSupportQuestion'] });
      }}
    />
  );
};
